/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Star",
  size: 20
}

const SvgStar = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      strokeWidth={1.01}
      d="M10 2l2.63 5.27 5.87.85-4.25 4.1 1 5.78L10 15.27 4.75 18l1-5.78-4.25-4.1 5.87-.85z"
    />
  </Svg>
)

SvgStar.defaultProps = defaultProps
export default SvgStar
